import AuthService from "@ergeon/erg-auth";
import settings from "config/settings";

const COOKIE_PARAM_NAME = "cookieName";
const OPTIONAL_SETTINGS = {};
if (process.env.AUTH_COOKIE_NAME) {
  OPTIONAL_SETTINGS[COOKIE_PARAM_NAME] = process.env.AUTH_COOKIE_NAME;
}

let authService;

export default () => {
  authService = authService || new AuthService({
    ...OPTIONAL_SETTINGS,
    appId: "ergeon",
    idService: process.env.ID_SERVICE_URL,
    userDetailsEndpoint: settings.AUTHENTICATE_URL,
    level: settings.LEVEL,
  });
  return authService;
};



/** WEBPACK FOOTER **
 ** ./src/app/auth.js
 **/